export default "https://cdn-static.gokick.com/assets/8bc125c24491fd75c87852671f08945500f37a20/images/spearmint-flavor.4c44d265d2ca14e44f653db82c437465.png";